// utils/googleAds.js

let adsIdInitialized = false;

/**
 * Load the global site tag (gtag.js) and initialize Google Ads
 * @param {string} adsId - Google Ads ID (e.g., 'AW-11321518946')
 */
export const loadGoogleAds = (adsId) => {
  if (!adsId || typeof window === 'undefined' || adsIdInitialized) return;

  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${adsId}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }

  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', adsId); // General tracking init
  adsIdInitialized = true;
};

/**
 * Send a conversion event to Google Ads
 * @param {string} sendTo - Conversion Label (e.g., 'AW-11321518946/XYZ123')
 */
export const triggerAdConversion = (sendTo) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', {
      send_to: sendTo,
    });
  }
};
